import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSelect = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.5565 5.70305C12.947 6.09357 12.947 6.72674 12.5565 7.11726L7.42382 12.2499C7.0333 12.6404 6.40013 12.6404 6.00961 12.2499L3.44328 9.68359C3.05276 9.29306 3.05276 8.6599 3.44328 8.26937C3.83381 7.87885 4.46697 7.87885 4.8575 8.26937L6.71672 10.1286L11.1423 5.70305C11.5328 5.31253 12.1659 5.31253 12.5565 5.70305Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgSelect);
export default ForwardRef;
